var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.9167C4.25 12.6958 4.8875 13.3333 5.66667 13.3333C6.44583 13.3333 7.08333 12.6958 7.08333 11.9167V9.08333H9.91667C10.6958 9.08333 11.3333 8.44583 11.3333 7.66667C11.3333 6.8875 10.6958 6.25 9.91667 6.25H7.08333V3.41667C7.08333 2.6375 6.44583 2 5.66667 2C4.8875 2 4.25 2.6375 4.25 3.41667V6.25H1.41667C0.6375 6.25 0 6.8875 0 7.66667C0 8.44583 0.6375 9.08333 1.41667 9.08333H4.25V11.9167Z",
    fill: "#86B818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4166 24.6667C20.7638 24.6667 22.6666 22.764 22.6666 20.4167C22.6666 18.0695 20.7638 16.1667 18.4166 16.1667C16.0694 16.1667 14.1666 18.0695 14.1666 20.4167C14.1666 22.764 16.0694 24.6667 18.4166 24.6667Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 9.08333H25.2592L23.5025 7.17083C22.9783 6.59 22.2133 6.25 21.42 6.25H12.3533C12.5942 6.675 12.75 7.1425 12.75 7.66667C12.75 9.225 11.475 10.5 9.91667 10.5H8.5V11.9167C8.5 13.475 7.225 14.75 5.66667 14.75C5.1425 14.75 4.675 14.5942 4.25 14.3533V28.9167C4.25 30.475 5.525 31.75 7.08333 31.75H29.75C31.3083 31.75 32.5833 30.475 32.5833 28.9167V11.9167C32.5833 10.3583 31.3083 9.08333 29.75 9.08333ZM18.4167 27.5C14.5067 27.5 11.3333 24.3267 11.3333 20.4167C11.3333 16.5067 14.5067 13.3333 18.4167 13.3333C22.3267 13.3333 25.5 16.5067 25.5 20.4167C25.5 24.3267 22.3267 27.5 18.4167 27.5Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/addPhoto.d9ca92e2.svg";
export { ForwardRef as ReactComponent };